import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';
import { getTruncateMaxLinesStyle } from '../../styles';
import { WbLink } from '../WbLink';

export type WbBreadcrumbProps = {
  children: ReactNode;
  to?: string;
  linkClassName?: string;
  style?: CSSProperties;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      ...getTruncateMaxLinesStyle(1, true),
    },
    link: {
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
  }),
  { name: 'WbBreadcrumb' },
);

export const WbBreadcrumb = ({
  to,
  children,
  linkClassName,
  style,
}: WbBreadcrumbProps) => {
  const classes = useStyles();

  if (to !== undefined)
    return (
      <WbLink
        color="inherit"
        to={to}
        className={clsx(classes.root, classes.link, linkClassName)}
        style={style}
      >
        {children}
      </WbLink>
    );

  return <Box className={clsx(classes.root, linkClassName)}>{children}</Box>;
};
